import { MeasurementUnit } from '@core/Types/Measurement'

export type Option<T> = {
    label: string
    value: T
}

export const MEASUREMENT_UNIT_OPTIONS: Option<MeasurementUnit>[] = [
    { label: 'cms', value: 'cms' },
    { label: 'inch', value: 'in' },
]
